readEscapedCharacter